import { LayoutRows2 } from '@juvare/common-web-ui/LayoutRows2';
import { Tab, Tabs } from '@mui/material';
import React from 'react';
import { Inbox, InboxType } from './index';

export default (): React.ReactElement => {
    const [activeType, setActiveType] = React.useState<InboxType>('received');
    return (
        <LayoutRows2
            row1={
                <Tabs
                    indicatorColor='primary'
                    textColor='primary'
                    value={activeType}
                    onChange={(event, newValue) => setActiveType(newValue)}
                >
                    <Tab value='received' label='Received' />
                    <Tab value='archived' label='Archived' />
                </Tabs>
            }
            row2={<Inbox type={activeType} multiSelect={true} />}
            fullHeightRow='row2'
        />
    );
};


export const src = "import { LayoutRows2 } from '@juvare/common-web-ui/LayoutRows2';\nimport { Tab, Tabs } from '@mui/material';\nimport React from 'react';\nimport { Inbox, InboxType } from './index';\n\nexport default (): React.ReactElement => {\n    const [activeType, setActiveType] = React.useState<InboxType>('received');\n    return (\n        <LayoutRows2\n            row1={\n                <Tabs\n                    indicatorColor='primary'\n                    textColor='primary'\n                    value={activeType}\n                    onChange={(event, newValue) => setActiveType(newValue)}\n                >\n                    <Tab value='received' label='Received' />\n                    <Tab value='archived' label='Archived' />\n                </Tabs>\n            }\n            row2={<Inbox type={activeType} multiSelect={true} />}\n            fullHeightRow='row2'\n        />\n    );\n};\n";